<template>
  <div>
    <p class="font-bold mb-5">Manually enter your address</p>
    <form class="h-full flex flex-col justify-between" @submit="submitForm">
      <div>
        <DrInput
          ref="addressLine1"
          v-model="address.line1"
          :error="errors.line1"
          data-label="Line 1"
          class="mb-6"
          placeholder="Line 1"
        />
        <DrInput v-model="address.line2" :error="errors.line2" data-label="Line 2" class="mb-6" placeholder="Line 2" />
        <DrInput v-model="address.city" :error="errors.city" data-label="Town" class="mb-6" placeholder="Town" />
        <DrInput
          v-model="address.postcode"
          :error="errors.postcode"
          data-label="Postcode"
          class="mb-6"
          placeholder="Postcode"
        />
        <div class="w-full relative mb-6">
          <div v-ClickOutside="hideCountries">
            <DrInput
              ref="addressInput"
              v-model="address.country"
              :error="errors.country"
              class="mb-1"
              data-label="Country"
              placeholder="Country"
              disabled
            />
          </div>
        </div>
      </div>
      <div>
        <DrButton :loading="loading" class="w-full btn-blue" @click="submitForm">Done</DrButton>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ClickOutside from '../../directives/ClickOutside'
import countries from '../../static/countries.json'

export default {
  directives: {
    ClickOutside,
  },
  data () {
    return {
      address: {
        line1: '',
        line2: '',
        line3: '',
        city: '',
        postcode: '',
        country: 'United Kingdom',
      },
      errors: {},
      showCountries: false,
      loading: false,
    }
  },
  computed: {
    countriesList () {
      const displayData = countries.slice(0)
      let count = 0

      if (this.address.country.length) {
        displayData.forEach((country, index) => {
          if (country.toLowerCase().startsWith(this.address.country.toLowerCase())) {
            displayData.splice(count, 0, displayData.splice(index, 1)[0])
            count++
          }
        })
      }
      return displayData.filter(country => country.toLowerCase().includes(this.address.country.toLowerCase()))
    },
  },
  mounted () {
    this.$refs.addressLine1.$refs.input.focus()
  },
  methods: {
    ...mapActions({
      storePremises: 'premises/storePremises',
    }),
    selectCountry (value) {
      this.address.country = value
      this.showCountries = false
    },
    hideCountries () {
      this.showCountries = false
    },
    submitForm () {
      this.loading = true
      this.errors = {}
      this.storePremises({
        quoteId: this.$store.state.quoteId,
        formData: this.address,
      })
        .then(() => {
          this.loading = false
          this.$router.push('/checkout/policyholder')
        })
        .catch((error) => {
          this.loading = false
          Object.keys(error.response.data.errors).forEach((field) => {
            this.errors[field] = error.response.data.errors[field][0]
          })
        })
    },
  },
}
</script>
